
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
import { withProps } from 'src/utils/withProps';
import {Android} from './Android'
import {Ios} from './Ios'

type TParams = { id: string };

export function SdkVersionEditor(props: RouteComponentProps<TParams>) {
    
    return (
        <div>
            <Switch>
                <Route path={[
                    '/sdk_editor/android/copy/:id', 
                ]} component={withProps(Android, { action: 'copy', ...props })}  />

                <Route path={[
                    '/sdk_editor/android/:id', 
                    '/sdk_editor/android'
                ]} component={withProps(Android, { ...props })}  />

                <Route path={[
                    '/sdk_editor/ios/copy/:id', 
                ]} component={withProps(Ios, { action: 'copy', ...props })}  />

                <Route path={[
                    '/sdk_editor/ios/:id', 
                    '/sdk_editor/ios'
                ]} component={withProps(Ios,  { ...props })}  />
            </Switch>
        </div>
    );
}       